import { Button, type ButtonProps } from "react-bootstrap";
import { MdAdd } from "react-icons/md";

const NewButton: TTButtonProps = ({ children, ...props }) => (
  <Button variant="secondary" size="sm" {...(props as ButtonProps)}>
    <MdAdd /> {children}
  </Button>
);

export default NewButton;
